import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { DisplayEuro } from '../../../../../../../utils/formats';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
import theme from '../../../../../../../assets/theme/theme';
const P = Schema.attributes;

const FinanzierungsplanSkizzeEmob: FC<{}> = () => {
	const { application } = useApplication();

	const allKostenPosition = useMemo(() => {
		return get(application, P.Foerderantrag_Kostenpositions.path);
	}, [application]);

	const { groupedData, totals } = transformDataSkizze(allKostenPosition);

	return (
		<>
			<ApplicationHeading title="Ausgaben- und Finanzierungsplan" description={PLATZHALTER_TEXT} />
			<TableContainer>
				<Table size="medium" aria-label="a dense table">
					<TableHead>
						<TableRow>
							<TableCell></TableCell>
							<TableCell>Gesamt</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{Object.values(groupedData).map((group: any, index: number) => (
							<React.Fragment key={index}>
								<TableRow>
									<TableCell sx={{ backgroundColor: theme.palette.background.paper }} colSpan={2}>
										{group.companyName}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Ausgaben</TableCell>
									<TableCell>{DisplayEuro(group.gesamtAusgabe)}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Eigen- und Drittmittel</TableCell>
									<TableCell>{DisplayEuro(group.gesamtEinnahme)}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Individuelle Förderquote</TableCell>
									<TableCell>{group.averageFoerderquote}%</TableCell>
								</TableRow>
							</React.Fragment>
						))}
						<TableRow className='total-row'>
							<TableCell>Gesamtausgaben</TableCell>
							<TableCell>{DisplayEuro(totals.gesamtGesamtausgaben)}</TableCell>
						</TableRow>
						<TableRow className='total-row'>
							<TableCell>Summe Eigen- und Drittmittel</TableCell>
							<TableCell>{DisplayEuro(totals.gesamtSummeEinnahme)}</TableCell>
						</TableRow>
						<TableRow className='total-row'>
							<TableCell>Zuwendung</TableCell>
							<TableCell>{DisplayEuro(totals.gesamtSummeZuwendung)}</TableCell>
						</TableRow>
						<TableRow className='total-row'>
							<TableCell>Förderquote</TableCell>
							<TableCell>{totals.gesamtDivisionZuwendungEinnahme}%</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};
export default FinanzierungsplanSkizzeEmob;

export function transformDataSkizze(data: any) {
	const groupedData: any = {};

	// Group by Unternehmen.id and calculate the totals directly from Allgemein_Geplante_Gesamtsumme
	data?.forEach((item: any) => {
		const { attributes } = item;
		const companyId = attributes.Unternehmen.id;
		const companyName = attributes.Unternehmen.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation;

		if (!groupedData[companyId]) {
			groupedData[companyId] = {
				companyName,
				gesamtAusgabe: 0,
				gesamtEinnahme: 0,
			};
		}

		const plannedSum = parseFloat(attributes.Allgemein_Geplante_Gesamtsumme) || 0;

		if (attributes.Allgemein_Kostenposition === 'Ausgabe') {
			groupedData[companyId].gesamtAusgabe += plannedSum;
		} else if (attributes.Allgemein_Kostenposition === 'Einnahme') {
			groupedData[companyId].gesamtEinnahme += plannedSum;
		}
	});

	// Calculate individuelle Förderquote
	Object.values(groupedData).forEach((group: any) => {
		group.averageFoerderquote = (((group.gesamtAusgabe - group.gesamtEinnahme) / group.gesamtAusgabe) * 100).toFixed(2);
	});

	// Calculate overall totals
	const totals: any = {
		gesamtGesamtausgaben: 0,
		gesamtSummeEinnahme: 0,
		gesamtSummeZuwendung: 0,
		gesamtDivisionZuwendungEinnahme: 0,
	};

	Object.values(groupedData).forEach((group: any) => {
		totals.gesamtGesamtausgaben += group.gesamtAusgabe;
		totals.gesamtSummeEinnahme += group.gesamtEinnahme;
	});

	totals.gesamtSummeZuwendung = (totals.gesamtGesamtausgaben - totals.gesamtSummeEinnahme).toFixed(2);

	totals.gesamtDivisionZuwendungEinnahme = (
		(parseFloat(totals.gesamtSummeZuwendung) / totals.gesamtGesamtausgaben) *
		100
	).toFixed(2);

	return { groupedData, totals };
}
